module.exports = __webpack_public_path__ + "static/media/app-store.19eb94c7.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/app-store.png
// module id = 366
// module chunks = 0